module.exports = __webpack_public_path__ + "img/ruoyi3.e06163f4.png";